import React, { useCallback, useMemo, useRef } from 'react';

import { PointerPosition } from './AutoSuggestAutocomplete.interface';

export function useAutoSuggestAutocomplete() {
  const lastPointerPosition = useRef<PointerPosition | null>(null);

  const rememberPointerPosition = useCallback((event: React.MouseEvent) => {
    lastPointerPosition.current = { x: event.clientX, y: event.clientY };
  }, []);

  const handleMouseOverCapture = useCallback(
    (event: React.MouseEvent) => {
      const previousPosition = lastPointerPosition.current;
      const hasPointerMoved =
        !previousPosition ||
        previousPosition.x !== event.clientX ||
        previousPosition.y !== event.clientY;

      rememberPointerPosition(event);

      if (!hasPointerMoved) {
        event.stopPropagation();
      }
    },
    [rememberPointerPosition]
  );

  const listboxProps = useMemo(
    () => ({
      onMouseMove: rememberPointerPosition,
      onMouseOverCapture: handleMouseOverCapture,
    }),
    [rememberPointerPosition, handleMouseOverCapture]
  );

  return { listboxProps };
}
